const env = process.env.REACT_APP_ENV || 'development';
module.exports = require(`./${env}`).default;